@if (notifications$().length > 0) {
  <div class="sol-notification-list-container" role="status" aria-live="polite">
    <div class="sol-notification-list">
      @for (notification of notifications$(); track notification.id) {
        <div [class]="notification.notificationClass">
          <sol-icon class="sol-notification-icon" [name]="notification.icon" />
          <div class="sol-notification-message">
            {{ notification.text | translate: notification.textParams }}
          </div>
          @if (notification.count > 1) {
            <div class="sol-notification-count">({{ notification.count }})</div>
          }
          <div class="sol-notification-actions">
            @if (notification.actionText) {
              <sol-button
                [type]="SolButtonType.transparent"
                (click)="doAction(notification.id)"
                [text]="notification.actionText"
              >
              </sol-button>
            }
            @if (notification.closeable) {
              <sol-button
                [type]="SolButtonType.transparent"
                [icon]="SolIcon.remove"
                (click)="close(notification.id)"
              ></sol-button>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
